import React from 'react'
import t from 'prop-types'

const FourUp = ({ children }) => {
  return (
    <div className="md:grid md:grid-cols-2 lg:grid-cols-4 col-gap-10 row-gap-24">
      {children.map((child, index) => (
        <div key={index} className="mb-16 md:mb-0 last:mb-0">
          {child}
        </div>
      ))}
    </div>
  )
}

FourUp.propTypes = {
  children: t.node.isRequired,
}

FourUp.defaultProps = {}

export default FourUp
